import "@ncp/ui/fonts";
import "./index.css";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { I18nProvider, createI18n } from "@ncp/i18n";
import { App } from "./App";
import adminEn from "./locales/en";
import adminAr from "./locales/ar";

const i18n = createI18n({
  resources: {
    en: { admin: adminEn },
    ar: { admin: adminAr },
  },
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <I18nProvider i18n={i18n}>
      <App />
    </I18nProvider>
  </StrictMode>,
);
